'use client';

import { Container } from 'components/shared';
// import { hideScrollbar, CustomImage as Image } from '../..';
import { useContext } from 'react';
// import { SkinTemperatureModal } from './SkinTemperatureModal';
import { DesktopRecoveryComponent } from './DesktopRecoveryComponent';
import { MobileRecoveryComponent } from './MobileRecoveryComponent';
import { HRVfactorModal } from './HRVfactorModal';
import { StressModal } from './StressModal';
import { DynamicRecoveryModal } from './DynamiCRecoveryModal';
import { MagicModalNewContext } from 'components/shared/MagicModalNew';
import { SkinTemperatureModal } from './SkinTemperatureModal';
import { analytics } from 'lib/analytics/analytics';
import styles from './index.module.css';

export const UnderstandYourRecovery = ({
  className,
}: {
  className?: string;
}) => {
  const MagicModalNewClient = useContext(MagicModalNewContext);

  const handleDynamicRecoveryModal = () => {
    analytics.track('dynamic recovery modal - CLICK');
    MagicModalNewClient.set(<DynamicRecoveryModal />);
    MagicModalNewClient.show();
  };

  const handleStressModal = () => {
    analytics.track('stress modal - CLICK');
    MagicModalNewClient.set(<StressModal />);
    MagicModalNewClient.show();
  };

  const handleSkinTemperatureModal = () => {
    analytics.track('skin temperature modal - CLICK');
    MagicModalNewClient.set(<SkinTemperatureModal />);
    MagicModalNewClient.show();
  };

  const handleHRVfactorModal = () => {
    analytics.track('hrv factor modal - CLICK');
    MagicModalNewClient.set(<HRVfactorModal />);
    MagicModalNewClient.show();
  };

  return (
    <section className={className ? `${styles.root} ${className}` : styles.root}>
      <Container>
        {/* both branches render; CSS picks one at 993px (useWindowSize is 0 on SSR) */}
        <DesktopRecoveryComponent
          className="recovery-desktop"
          handleDynamicRecovery={handleDynamicRecoveryModal}
          handleHRVfactor={handleHRVfactorModal}
          handleSkinTemperature={handleSkinTemperatureModal}
          handleStress={handleStressModal}
        />
        <MobileRecoveryComponent
          className="recovery-mobile"
          handleDynamicRecovery={handleDynamicRecoveryModal}
          handleHRVfactor={handleHRVfactorModal}
          handleSkinTemperature={handleSkinTemperatureModal}
          handleStress={handleStressModal}
        />
      </Container>

      {/* <MagicModal /> */}
    </section>
  );
};
